import type { Font } from '../types/font';
import { cyrillicExt } from '../types/unicode-range';

export const loraV24: Font = {
  fontFamily: 'lora-v24-cTfKnfW8REGn5u0XIrBnk',
  displayName: 'Lora',
  sources: [
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'lora-v24-latin-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'lora-v24-cyrillic-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'lora-v24-cyrillic-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: cyrillicExt,
      src: 'lora-v24-cyrillic-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: cyrillicExt,
      src: 'lora-v24-cyrillic-ext-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: cyrillicExt,
      src: 'lora-v24-cyrillic-ext-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: cyrillicExt,
      src: 'lora-v24-cyrillic-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'lora-v24-cyrillic-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'lora-v24-cyrillic-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'lora-v24-latin-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'lora-v24-latin-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'lora-v24-latin-ext-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'lora-v24-latin-ext-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'lora-v24-latin-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'lora-v24-latin-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'lora-v24-latin-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'lora-v24-vietnamese-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'lora-v24-vietnamese-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'lora-v24-vietnamese-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'lora-v24-vietnamese-regular.woff2',
      format: 'woff2',
    },
  ],
};
